"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Formatsqr6020MembersXL = exports.sqr6020MembersXL = exports.Formatsqr6020XL = exports.sqr6020XL = void 0;
const Maybe_1 = require("../../lib/Maybe");
const Util_1 = require("../../lib/Util");
const ramda_1 = require("ramda");
const __1 = require("../..");
const getPromotionRequirementsForMember = __1.memoize((loopmember) => loopmember.member.type === 'CAPProspectiveMember'
    ? undefined
    : __1.CadetHFZRequirementsMap.find(hfzentry => hfzentry.Gender === loopmember.member.gender &&
        hfzentry.Age ===
            (Math.floor((new Date().getTime() -
                loopmember.member.dateOfBirth) /
                (1000 * 60 * 60 * 24 * 365)) > 18
                ? 18
                : Math.floor((new Date().getTime() -
                    loopmember.member.dateOfBirth) /
                    (1000 * 60 * 60 * 24 * 365)))), requirements => requirements.member.id);
const sqr6020XL = () => {
    let row = [
        'Event Manager Healthy Fitness Zone Status Report SQR 60-20',
    ];
    const retVal = [];
    retVal.push(row);
    retVal.push(['This document was generated on: ', '', '', Date.now()]);
    retVal.push([]);
    retVal.push([]);
    row = ['Comments'];
    retVal.push(row);
    retVal.push([]);
    return retVal;
};
exports.sqr6020XL = sqr6020XL;
const Formatsqr6020XL = (sheet) => {
    const dateFormat = 'mm/dd/yyyy hh:mm';
    const dateWidth = dateFormat.length;
    sheet['!merges'] = [
        { s: { c: 0, r: 0 }, e: { c: 4, r: 0 } },
        { s: { c: 0, r: 1 }, e: { c: 2, r: 1 } },
        { s: { c: 1, r: 7 }, e: { c: 4, r: 7 } },
    ];
    sheet.D2.t = 'd';
    sheet.D2.z = dateFormat;
    sheet['!cols'] = [
        { width: 12 },
        { width: 12 },
        { wch: dateWidth },
        { wch: dateWidth },
        { width: 25 },
    ];
    sheet['!rows'] = [{ hpx: 19 }, { hpx: 17 }, {}, {}, {}];
    return sheet;
};
exports.Formatsqr6020XL = Formatsqr6020XL;
const sqr6020MembersXL = (nhqmembers, prospectiveMembers) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    let widths = [];
    let row = [
        'CAPID',
        'GradeOrder',
        'Full Name',
        'HFZ Expire Date',
        'Pacer Req.',
        'Pacer Score',
        'Mile Run Req.',
        'Mile Run Score',
        'Curl Up Req.',
        'Curl Up Score',
        'Push Up Req.',
        'Push Up Score',
        'Sit Reach Req.',
        'Sit Reach Score',
    ];
    const retVal = [];
    widths = [...row.map(item => item.toString().length)];
    retVal.push(row);
    const sortByMemberName = (a, b) => {
        const aMember = 'member' in a ? a.member : a;
        const bMember = 'member' in b ? b.member : b;
        return `${aMember.nameLast}, ${aMember.nameFirst}`.localeCompare(`${bMember.nameLast}, ${bMember.nameFirst}`);
    };
    const getHFZExpire = (reqs) => ramda_1.pipe(Util_1.get('HFZRecord'), Maybe_1.Maybe.filter(({ IsPassed }) => IsPassed || reqs.CurrentCadetAchv.CadetAchvID < 4), Maybe_1.Maybe.map(({ DateTaken }) => DateTaken.substr(0, 10)), Maybe_1.Maybe.map(s => +new Date(s) + 182 * 24 * 60 * 60 * 1000), Maybe_1.Maybe.map(s => new Date(s).toLocaleDateString('en-US')), Maybe_1.Maybe.orSome(''))(reqs);
    const phase1Cadets = nhqmembers;
    const phase1CadetsDoc = [
        ...phase1Cadets,
        ...prospectiveMembers.filter(mem => mem.memberRank === 'CADET'),
    ]
        .sort(sortByMemberName)
        .map((mem) => ({
        requirements: 'requirements' in mem ? mem.requirements : null,
        member: 'member' in mem ? mem.member : mem,
    }));
    for (const loopmember of phase1CadetsDoc) {
        console.log(loopmember.requirements !== null
            ? getHFZExpire(loopmember.requirements)
            : 'reqs = null', loopmember.requirements);
        row = [
            loopmember.member.id.toString(),
            ((_a = loopmember.requirements) === null || _a === void 0 ? void 0 : _a.CurrentCadetAchv.CadetAchvID.toString())
                ? (_b = loopmember.requirements) === null || _b === void 0 ? void 0 : _b.CurrentCadetAchv.CadetAchvID.toString()
                : '',
            `${loopmember.member.memberRank} ${loopmember.member.nameLast}, ${loopmember.member.nameFirst}`,
            loopmember.requirements !== null ? getHFZExpire(loopmember.requirements) : '',
            (_d = (_c = getPromotionRequirementsForMember(loopmember)) === null || _c === void 0 ? void 0 : _c.Pacer) !== null && _d !== void 0 ? _d : '',
            '',
            (_f = (_e = getPromotionRequirementsForMember(loopmember)) === null || _e === void 0 ? void 0 : _e.MileRun) !== null && _f !== void 0 ? _f : '',
            '',
            (_h = (_g = getPromotionRequirementsForMember(loopmember)) === null || _g === void 0 ? void 0 : _g.CurlUps) !== null && _h !== void 0 ? _h : '',
            '',
            (_k = (_j = getPromotionRequirementsForMember(loopmember)) === null || _j === void 0 ? void 0 : _j.PushUps) !== null && _k !== void 0 ? _k : '',
            '',
            (_m = (_l = getPromotionRequirementsForMember(loopmember)) === null || _l === void 0 ? void 0 : _l.SitReach) !== null && _m !== void 0 ? _m : '',
            '',
        ];
        retVal.push(row);
    }
    return [retVal, widths.map(width => width + 3)];
};
exports.sqr6020MembersXL = sqr6020MembersXL;
const Formatsqr6020MembersXL = (sheet, columnMaxWidths, numRows) => {
    const dateFormat = 'yyyy-mm-dd';
    const dateWidth = dateFormat.length + 1;
    const rowHeight = 22;
    sheet['!rows'] = [{ hpt: rowHeight }];
    let j = 2;
    while (j <= numRows) {
        j += 1;
    }
    sheet['!cols'] = columnMaxWidths.map(wch => ({ wch }));
    sheet['!cols'] = [
        { width: 8 },
        { width: 15 },
        { width: 32 },
        { wch: dateWidth },
        { width: 12 },
        { width: 12 },
        { width: 12 },
        { width: 12 },
        { width: 12 },
        { width: 12 },
        { width: 12 },
        { width: 12 },
        { width: 12 },
        { width: 12 },
    ];
    return sheet;
};
exports.Formatsqr6020MembersXL = Formatsqr6020MembersXL;
//# sourceMappingURL=sqr6020.js.map